import { render, staticRenderFns } from "./ValueBox.vue?vue&type=template&id=5f382a48&scoped=true"
import script from "./ValueBox.vue?vue&type=script&lang=js"
export * from "./ValueBox.vue?vue&type=script&lang=js"
import style0 from "./ValueBox.vue?vue&type=style&index=0&id=5f382a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f382a48",
  null
  
)

export default component.exports